export enum OtherSalaryMultiplierB {
DailySalary,
HourlyRate,
Fixed,
ExpressionType,
Empty,
}
